import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// 다국어(ko/en/ja/zh) 초기화 — App 이 그려지기 전에 언어를 정한다 (docs/ops/app-i18n-plan.md)
import { i18nReady } from './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { prepareLiveUpdates } from './lib/liveUpdates';
import MobileUpdateStartupGate, { StartupLoadingScreen } from './components/MobileUpdateStartupGate';

// 🔒 App 은 사전이 들어온 뒤에 읽는다. 모듈 최상위에서 tt() 를 부르는 파일이 사전 없이 굳지 않게 하려는 것이다.
// webpackMode "eager" — 따로 파일을 나누지 않고 main 에 그대로 두되, 실행만 미룬다(요청 한 번 더 늘지 않는다).
const loadApp = () => i18nReady.then(() => import(/* webpackMode: "eager" */ './App')).then((m) => m.default);

async function startApp(root) {
  let App;
  try {
    await serviceWorkerRegistration.prepareNativeServiceWorker();
    const [shouldRender, LoadedApp] = await Promise.all([prepareLiveUpdates(), loadApp()]);
    App = LoadedApp;
    // A native bundle switch reloads this JavaScript context. Keep the
    // loader visible in the old context until that reload happens.
    if (!shouldRender) return;
    root.render(
      <MobileUpdateStartupGate>
        <App />
      </MobileUpdateStartupGate>,
    );
  } catch (error) {
    console.warn('[App bootstrap] Starting the current app bundle:', error);
    if (!App) App = await loadApp();
    root.render(
      <MobileUpdateStartupGate>
        <App />
      </MobileUpdateStartupGate>,
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<StartupLoadingScreen />);
void startApp(root);

// Register service worker for PWA support
serviceWorkerRegistration.register();
